/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type VehicleTableHubFilterQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type VehicleTableHubFilterQuery = {
  __typename?: 'Query'
  hubs: {
    __typename?: 'HubsResponse'
    hubs: Array<{
      __typename?: 'Hub'
      id: string
      name: string
      displayName: string
      serviceAreaUUID: string
    }>
  }
}

export const VehicleTableHubFilterDocument = gql`
    query vehicleTableHubFilter {
  hubs {
    hubs {
      id
      name
      displayName
      serviceAreaUUID
    }
  }
}
    `

/**
 * __useVehicleTableHubFilterQuery__
 *
 * To run a query within a React component, call `useVehicleTableHubFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleTableHubFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleTableHubFilterQuery({
 *   variables: {
 *   },
 * });
 */
export function useVehicleTableHubFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    VehicleTableHubFilterQuery,
    VehicleTableHubFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    VehicleTableHubFilterQuery,
    VehicleTableHubFilterQueryVariables
  >(VehicleTableHubFilterDocument, options)
}
export function useVehicleTableHubFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VehicleTableHubFilterQuery,
    VehicleTableHubFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    VehicleTableHubFilterQuery,
    VehicleTableHubFilterQueryVariables
  >(VehicleTableHubFilterDocument, options)
}
export function useVehicleTableHubFilterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        VehicleTableHubFilterQuery,
        VehicleTableHubFilterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    VehicleTableHubFilterQuery,
    VehicleTableHubFilterQueryVariables
  >(VehicleTableHubFilterDocument, options)
}
export type VehicleTableHubFilterQueryHookResult = ReturnType<
  typeof useVehicleTableHubFilterQuery
>
export type VehicleTableHubFilterLazyQueryHookResult = ReturnType<
  typeof useVehicleTableHubFilterLazyQuery
>
export type VehicleTableHubFilterSuspenseQueryHookResult = ReturnType<
  typeof useVehicleTableHubFilterSuspenseQuery
>
export type VehicleTableHubFilterQueryResult = Apollo.QueryResult<
  VehicleTableHubFilterQuery,
  VehicleTableHubFilterQueryVariables
>
